import React from 'react';
import styles from './Header.module.scss';
import { useTranslation } from 'react-i18next';
import { orderList } from '../util';

type Props = {
  editMode: boolean;
  handleClick?: any;
};

const Header = ({ editMode, handleClick }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} header-title`}>
      {orderList.map(item => (
        <div className={`${styles.listItem} item`} key={item.encodedName}>
          {editMode ? (
            <div className={styles.text}>{t(item.langKey)}</div>
          ) : (
            <div className={styles.clickableText} onClick={() => handleClick(item.encodedName)}>
              {t(item.langKey)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Header;
